import { useMemo } from 'react'
import classNames from 'classnames'
import { EmptyCircleIcon } from '@/atoms/Icons/EmptyCircleIcon'
import { ParagraphSM } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'
import { TorchApplicationTypes, useTorchApplication } from './TorchApplicationContext'

export const SubmitTorchApplicationProgress = () => {
  const { t } = useTranslate('guild-create')
  const { pageIndex, type } = useTorchApplication()

  const isFullFilm = type === TorchApplicationTypes.FullFilm
  const isEpisode = type === TorchApplicationTypes.CompletedEpisode

  const pageNames = useMemo(
    () => [
      t('page1SubmissionType', 'Submission Type'),
      t('page2FilmmakerCompanyTorchDetails', 'Filmmaker, Company, & Torch Details'),
      t('page4TermsConditionsSubmissionAgreement', 'Terms, Conditions, & Submission Agreement'),
      t('page5MediaUpload', 'Media Upload'),
      t('page6ApplicationFeePayment', 'Application Fee & Payment'),
    ],
    [t],
  )

  const episodePageNames = useMemo(
    () => [
      t('page1SubmissionType', 'Submission Type'),
      t('page2FilmmakerCompanyTorchDetails', 'Filmmaker, Company, & Torch Details'),
      t('page4TermsConditionsSubmissionAgreement', 'Terms, Conditions, & Submission Agreement'),
      t('page5MediaUpload', 'Media Upload'),
      t('associatedProject', 'Associated Project'),
      t('page6ApplicationFeePayment', 'Application Fee & Payment'),
    ],
    [t],
  )

  const fullFilmPageNames = useMemo(
    () => [
      t('page1SubmissionType', 'Submission Type'),
      t('page2ReviewFilmDetails', 'Review Film Details'),
      t('page3FullLengthFilmUpload', 'Full-Length Film Upload'),
      t('page4FullLengthApplicationFeePayment', 'Full-Length Application Fee & Payment'),
    ],
    [t],
  )

  const pages = useMemo(() => {
    if (isFullFilm) return fullFilmPageNames
    if (isEpisode) return episodePageNames

    return pageNames
  }, [fullFilmPageNames, episodePageNames, pageNames, isFullFilm, isEpisode])

  return (
    <div className="flex select-none flex-col gap-1">
      <div className="flex flex-row gap-2">
        {Array.from({ length: pages.length }).map((_, i) => (
          <PagePill key={i} reached={i <= pageIndex} />
        ))}
      </div>
      <div className="flex flex-col lg:flex-row lg:items-center lg:gap-1.5">
        <ParagraphSM weight="bold" className="hidden lg:block">
          {pageIndex + 1} of {pages.length}
        </ParagraphSM>
        <EmptyCircleIcon color1="core-gray-950" color2="core-gray-950" size={6} className="hidden lg:block" />
        <ParagraphSM weight="normal">{pages[pageIndex]}</ParagraphSM>
      </div>
    </div>
  )
}

const PagePill = ({ reached = false }) => {
  return (
    <div className="relative h-2 w-12 overflow-hidden rounded-lg bg-core-gray-300 lg:w-[72px]">
      <div
        className={classNames(
          'absolute inset-0 transition-transform duration-300 bg-core-gray-950',
          !reached && '-translate-x-full',
        )}
      />
    </div>
  )
}
